<template>
  <div class="page">
    You don't have sufficient permissions to access this page.
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
